import React from "react";

const VerticalLines = () => {
  return (
    <div>
      <div className="container-fluid">
        <div className="item-efftect container">
          <div className="efftect overflow-hidden"></div>
          <div className="efftect overflow-hidden"></div>
          <div className="efftect overflow-hidden"></div>
          <div className="efftect overflow-hidden"></div>
          <div className="efftect overflow-hidden"></div>
        </div>
      </div>
    </div>
  );
};

export default VerticalLines;
